export type RuntimeChannel = 'web' | 'apps_in_toss';

export interface ChannelRuntime {
  __ANJABOM_RUNTIME_CHANNEL__?: RuntimeChannel;
}

export function runtimeChannel(runtime: ChannelRuntime = globalThis as ChannelRuntime): RuntimeChannel {
  return runtime.__ANJABOM_RUNTIME_CHANNEL__ === 'apps_in_toss' ? 'apps_in_toss' : 'web';
}

export function isAppsInTossChannel(runtime?: ChannelRuntime): boolean {
  return runtimeChannel(runtime) === 'apps_in_toss';
}
